export default __webpack_public_path__ + "static/media/Wawanesa_Insurance_grey.273ae4af.svg";